import * as copy from 'src/common/templates/copy';

export const GLOBAL_SYMBOL = '*';
export const GLOBAL_DISPLAY_NAME = `All Databases`;
export const globalSymbolToName = (s: string) =>
  s === GLOBAL_SYMBOL ? GLOBAL_DISPLAY_NAME : s;
export const globalDisplayNameToSymbol = (s: string) =>
  s === GLOBAL_DISPLAY_NAME ? GLOBAL_SYMBOL : s;

export const SCOPE_TOOLTIP_MSG = `A query stored to a specific database can only be programmatically executed against that database.`;

export const abbreviate = (s: string, n = 0) =>
  s.length > n ? s.substr(0, n).concat('...') : s;

export const VOICEBOX_QUERY_PROMPT_TAG =
  copy.components.workspace.storedQueryPopover.voiceboxTags.prompt;
export const VOICEBOX_EXAMPLE_QUERY_TAG =
  copy.components.workspace.storedQueryPopover.voiceboxTags.example;
export const TRIGGER_QUERY_TAG = 'Trigger';

// Studio used to use 'Voicebox Query' instead of 'Voicebox Query Prompt' —
// both may exist on the server for queries edited before this change.
export const STUDIO_LEGACY_VOICEBOX_QUERY_TAG = 'Voicebox Query';

export const SYNTHETIC_QUERY_TAGS = new Set([
  VOICEBOX_QUERY_PROMPT_TAG,
  VOICEBOX_EXAMPLE_QUERY_TAG,
  TRIGGER_QUERY_TAG,
  STUDIO_LEGACY_VOICEBOX_QUERY_TAG,
]);

export const isSyntheticTag = (tag: string) => {
  const normalized = tag.trim().toLowerCase();
  return Array.from(SYNTHETIC_QUERY_TAGS).some(
    (syntheticTag) => syntheticTag.toLowerCase() === normalized
  );
};
